<template>
  <button class="btn-download" @click="download()">
    <span class="btn-download--icon"
      ><svgicon :name="'download'" height="1rem" width="1rem" />
    </span>

    <span class="btn-download--text">{{ content.text }}</span>
  </button>
</template>


<script>
export default {
  name: "BtnDownload",
  computed: {
    content() {
      return this.$t("landing").downloadBtn;
    },
  },
  methods: {
    download() {
      const pdf = this.content.href;
      window.open(pdf, "_blank").focus();

      window.digitalData.push({
        event: "click-download",
        pageEvent: {
          eventInfo: {
            eventDetail: "PDF",
            contentTitle: this.content.title,
            contentWidget: "wer",
            contentURL: pdf,
            ctaLabel: this.content.text,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-download {
  max-width: toRem(40);
  height: toRem(40);
  border-radius: toRem(40);

  position: absolute;

  left: 50%;
  // can't use transform here because it will cause the button to move on hover
  // 40 is the size of the button
  left: calc(50% - toRem(calc(40 / 2)));
  bottom: toRem(50);

  background-color: $primary-yellow;

  display: inline-flex;
  align-items: center;
  overflow: hidden;
  width: auto;
  transition: max-width 0.5s;

  &--icon {
    margin-right: toRem(10);
    padding: 0px toRem(12);
    display: flex;
    align-items: center;
  }

  &--text {
    white-space: nowrap;
    padding-right: toRem(15);
    @include link-xs;
  }

  &:hover {
    max-width: toRem(240);
  }
}
</style>